<template>
  <div class="a-modal">
    <div class="a-modal__wrapper">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AModal'
});
</script>

<style lang="scss" scoped>
.a-modal {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);

  &__wrapper {
    max-width: fit-content;
    padding: 16px;
    background: #fff;
    border-radius: 16px;
  }
}
</style>
